import {Action} from '@ngrx/store';
import {LOGOUT, LOGOUT_SUCCESS} from './actions';


export class Logout implements Action {
  readonly type = LOGOUT_SUCCESS;
}

export function clearState(reducer) {
  return function (state, action) {

    if (action.type === LOGOUT_SUCCESS) {
      state = undefined;
    }

    return reducer(state, action);
  };
}
